import { render, staticRenderFns } from "./OpeningStock.vue?vue&type=template&id=eba310a8&"
import script from "./OpeningStock.vue?vue&type=script&lang=js&"
export * from "./OpeningStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports